const HTTPS = {
  ALREADY_REPORTED: { code: 208, message: "Already Reported" },
  UNPROCESSABLE_ENTITY: { code: 422, message: "Unprocessable Entity" },
  UNAUTHORIZED: { code: 401, message: "Unauthorized" },
};

module.exports = { HTTPS };
